import { useState, useEffect } from "react";                    
import swal from 'sweetalert2';                     
import { getSubscriptionReportData } from "../api/reportsAPI";
import moment from "moment";
import { exportToExcel } from "../global/helper";

const SubscriptionReport = (props) => {
    const [isInit,                          setIsInit]                = useState(true);
    const [subscriptionReport,              setSubscriptionReport]    = useState(null);
    const [subscriptionTable,               setSubscriptionTable]     = useState(null);

    useEffect(() => {
        props.title('Subscription Report', 'subscription-report');

        getSubscriptionReport();
    }, []);

    useEffect(() => {
        if (!isInit) {
            fillTable();
        }
    }, [subscriptionReport]);

    const getSubscriptionReport = async() => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            const response = await getSubscriptionReportData();
            isInit ? setIsInit(false) : $('#tblSubscriptionReport').KTDatatable().destroy();
            setSubscriptionReport(response);
            swal.close();
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    function fillTable() {
        swal.close();
        const userData = subscriptionReport.User;

        const tblSubscription = $('#tblSubscriptionReport').KTDatatable({
            data: {
                saveState: false,
                source: userData
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'MembershipNo',
                    title: 'Membership No'
                },
                {
                    field: '',
                    title: 'Name',
                    width: 150,
                    template: function(row) {
                        return row['FirstName'] + ' ' + row['LastName'];
                    }
                },
                {
                    field: 'SubCategoryName',
                    title: 'Category'
                },
                {
                    field: 'Email',
                    title: 'Email',
                    width: 200,
                },
                {
                    field: 'Mobile',
                    title: 'Mobile'
                },   
                {
                    field: 'MembershipType',
                    title: 'Member Type',                    
                    template: (row) => row.MembershipType || ''
                },         
                {
                    field: 'Code',
                    title: 'Subs Type',
                    template: function (row) {
                        let plan = row?.Plan ? row?.Plan : '';
                        return row?.Code == 'Expired' ? `${plan}<span style="width: 60px;" class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10"> Expired </span>` 
                        : `${plan}<span  style="min-width: 60px;" class="kt-badge kt-badge--unified-${row?.MembershipTypeID == 1 ? 'success' 
                        : 'primary'} kt-badge--pill  kt-badge--bold badge-code">${row?.Code}</span>`
                    },
                    
                },
                {
                    field: 'SubscriptionExpiresOn',
                    title: 'Subs Exp On',
                    template: (row) => row.SubscriptionExpiresOn && moment(row.SubscriptionExpiresOn).format("DD-MM-YYYY") 
                },
               
                // {
                //     field: 'MembershipExpiresOn',
                //     title: 'Membs Exp On',
                //     template: (row) => moment(row.MembershipExpiresOn).format("DD-MM-YYYY")
                // },
                // {
                //     field: 'MembershipStatus',
                //     title: 'Membs status',
                //     template: function(row) {
                //         // if (row.IsMembershipExpires == 'N') {
                //         //     return '<span style="width: 60px;" class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10"> Expired </span>';
                //         // } else {
                //         //     return '<span style="width: 60px;" class="kt-badge kt-badge--unified-success kt-badge--pill  kt-badge--bold padding-lr20 padding-tb10">Valid</span>';
                //         // }
                //         if (row.IsMembershipExpires == 'N') {
                //             return '<span class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10">Expired</span>';
                //         } 
                //         else if (row.IsSubscriptionExpires == 'N') {
                //             return '<span class="kt-badge kt-badge--warning kt-badge--pill padding-lr30 padding-tb10">Block</span>';
                //         } 
                //         else {
                //             return '<span class="kt-badge kt-badge--unified-success kt-badge--pill kt-badge--bold padding-lr30 padding-tb10">Active</span>';
                //         }
                //     }
                // },                              
            ],
            rows: {
                autoHide: false,
            }
        });
        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblSubscriptionReport .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        const SubscriptionTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `Subscription Report`
        });

        setSubscriptionTable(SubscriptionTable);
        $('.tableexport-caption').addClass('hidden');
    };   

    function getExportData(sData) {
        return sData?.map(r => ({
            MembershipNo          : r.MembershipNo,
            Name                  :`${r.FirstName} ${r.LastName}`,
            Category              : r.SubCategoryName,
            Email                 : r.Email,
            Mobile                : r.Mobile,
            SubscriptionType      : r?.Code == 'Expired' ? `Expired` : r?.Plan,
            SubscriptionExpiresOn : r.SubscriptionExpiresOn && moment(r.SubscriptionExpiresOn).format("DD-MM-YYYY"),
            MembershipType        : r.MembershipType,
            MembershipExpiresOn   : moment(r.MembershipExpiresOn).format("DD-MM-YYYY"),
            MembershipStatus      :(r.IsMembershipExpires == 'N') ? 'Expired' : 'Active',
        }));
    }

    function exportSheet(type){
        /* @DESC ~PG
        *This Function Depends on XLSX lib attached in Public Index as CDN
        */
        const subscriptionData = subscriptionReport?.User

        if (!subscriptionData || subscriptionData.length === 0) {
            swal.fire({
                icon:'warning',
                titleText: 'No data to Export',                
                showConfirmButton: false,               
            });
            return;
        }

        let fileName = `Subscription Report - ${moment().format('YYYY-MM-DD')}`;
        const exportData = getExportData(subscriptionData);
        
        exportToExcel(type, exportData, fileName);       
    }

    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row justify-content-end">
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch"
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"                                                
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"                                                    
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="tblSubscriptionReport" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubscriptionReport;